import { clientsBannerList } from '@/assets/clients/clients-banner/clientsBanner';
import { ourClientsCompaniesList } from '@/assets/clients/our-clients-companies/ourClientsCompaniesList';

import type { ClientType } from './client-type';

export const clients: ClientType[] = [
  // 1️⃣ Pegasus
  {
    id: 'pegasus',
    name: 'Solar Racking Platform',
    image: clientsBannerList.pegasus,
    logo: ourClientsCompaniesList.pegasus,
    description:
      'A Series A-backed smart software solution that optimizes solar power operations through real-time monitoring, predictive maintenance, and intuitive control.',
    highlights: [
      { text: '$10M+', variant: 'neon-blue' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MOBILE', variant: 'neon-green' },
      { text: 'TECHNOLOGY', variant: 'neon-green' },
    ],
    services: [
      'Business Analysis',
      'UI/UX Design',
      'Consulting',
      'Frontend Development',
      'Backend Development',
      'AI Assistant',
    ],
    technologies: ['rails', 'react', 'typescript', 'docker', 'heroku', 'ai'],
    href: '/success-stories/pegasus-solar',
  },

  // 2️⃣ Junction
  {
    id: 'junction',
    name: 'Educational Learning Platform',
    image: clientsBannerList.junction,
    logo: ourClientsCompaniesList.junction,
    description:
      'Junction connects students, educators, and resources in one dynamic space, enabling custom learning paths, collaboration, and deeper engagement.',
    highlights: [
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MOBILE', variant: 'neon-green' },
      { text: 'EDUCATE', variant: 'neon-green' },
    ],
    technologies: ['javascript', 'angular', 'python', 'aws', 'ai'],
    services: [
      'Strategy',
      'UI/UX Design',
      'Testing & Performance',
      'Frontend Development',
      'Backend Development',
    ],
    href: '/success-stories/junction',
  },

  // 3️⃣ Pulsar
  {
    id: 'pulsar',
    name: 'Mine, Build, and Conquer. Real-Time Strategy Game',
    image: clientsBannerList.pulsar,
    logo: ourClientsCompaniesList.pulsar,
    description:
      'Pulsar is a Massively Multiplayer Online (MMO) Real-Time Strategy (RTS) game that allows players across the world to mine, build, and fight in a real-time battle.',
    highlights: [
      { text: '$3.6M+', variant: 'neon-blue' },
      { text: 'MARKETPLACE', variant: 'neon-green' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'NFT', variant: 'neon-green' },
    ],
    technologies: ['ethersjs', 'react', 'node', 'firebase'],
    services: [
      'Business Analysis',
      'UI/UX Design',
      'Testing & Performance',
      'Frontend Development',
      'Backend Development',
    ],
    href: '/success-stories/pulsar',
  },

  // 4️⃣ Modern Health
  {
    name: "Workforce's Mental Health App",
    image: clientsBannerList.modernHealth,
    logo: ourClientsCompaniesList.modernHealth,
    description:
      'Modern Health combines WHO well-being assessment, self-service wellness kits, a network of certified coaches, and licensed therapists in 35 languages into a seamless app.',
    highlights: [
      { text: '$170M+', variant: 'neon-blue' },
      { text: 'HEALTH', variant: 'neon-green' },
      { text: 'YC W18', variant: 'neon-green' },
      { text: '🦄 1M UNICORN', variant: 'neon-red' },
    ],
  },

  // 5️⃣ Whitesky
  {
    id: 'whitesky',
    name: 'MDU/MTU Networking Portal',
    image: clientsBannerList.whitesky,
    logo: ourClientsCompaniesList.whitesky,
    description:
      'A new brand powered by an abstract Wi-Fi symbol. In 2021, WhiteSky was acquired by RealPage (a $10B company) for a 9-figure amount.',
    highlights: [
      { text: '$10B+', variant: 'neon-blue' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MOBILE', variant: 'neon-green' },
      { text: 'PROPTECH', variant: 'neon-green' },
    ],
    technologies: [
      'django',
      'typescript',
      'python',
      'angular',
      'voip',
      'jenkins',
    ],
    services: [
      'Branding',
      'Business Analysis',
      'Frontend & Backend Development',
      'Desktop',
      'Testing & Performance',
      'Mobile & Desktop Development',
      'UX UI Design',
    ],
  },

  // 6️⃣ Benzinga
  {
    id: 'benzinga',
    name: 'Trading Heatmaps and Portfolio',
    image: clientsBannerList.benzinga,
    logo: ourClientsCompaniesList.benzinga,
    description:
      'Financial heat maps in tiles and tables showing stock market movers. Benzinga was acquired in 2021 by Beringer Capital PE (over $1B AUM) at a $300M valuation.',
    highlights: [
      { text: '$1B+', variant: 'neon-blue' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MOBILE', variant: 'neon-green' },
      { text: 'PROPTECH', variant: 'neon-green' },
    ],
    technologies: [
      'django',
      'typescript',
      'python',
      'angular',
      'voip',
      'jenkins',
    ],
    services: [
      'Ideation',
      'Frontend & Backend Development',
      'UX UI Design',
      'Business Analysis',
      'Testing & Performance',
      'Desktop Development',
    ],
  },

  // 7️⃣ Fayre
  {
    name: 'NFT Ecosystem for Brands',
    image: clientsBannerList.fayre,
    logo: ourClientsCompaniesList.fayre,
    description:
      'An NFT marketplace connected with community features and the ability to become a club member to pay a lower gas fee.',
    highlights: [
      { text: '$3.8M+', variant: 'neon-blue' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MARKETPLACE', variant: 'neon-green' },
      { text: 'NFT', variant: 'neon-green' },
    ],
  },

  // 8️⃣ Foodstuff
  {
    name: 'Food Delivery Conscience',
    image: clientsBannerList.foodstuff,
    logo: ourClientsCompaniesList.foodstuff,
    description:
      'Food delivery app working in the UK. Aims to become the first profitable Food Delivery App in the world.',
    highlights: [
      { text: '£1.3M+', variant: 'neon-blue' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MOBILE', variant: 'neon-green' },
      { text: 'FOODTECH', variant: 'neon-green' },
    ],
  },

  // 9️⃣ Manduka
  {
    name: 'Yoga Gear e-Commerce',
    image: clientsBannerList.manduka,
    logo: ourClientsCompaniesList.manduka,
    description:
      'Manduka is a health & wellness company specializing in yoga mats, clothing, and sustainable yoga products.',
    highlights: [
      { text: '$50M+', variant: 'neon-blue' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MOBILE', variant: 'neon-green' },
      { text: 'SPORT', variant: 'neon-green' },
    ],
  },

  // 🔟 Siren
  {
    name: 'Feet monitoring for Diabetics',
    image: clientsBannerList.siren,
    logo: ourClientsCompaniesList.siren,
    description:
      'Multi-specialty virtual care clinic leveraging proprietary technology to cost-effectively care for patients at risk of diabetic foot ulcers.',
    highlights: [
      { text: '$50M+', variant: 'neon-blue' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MOBILE', variant: 'neon-green' },
      { text: 'HEALTH', variant: 'neon-green' },
    ],
  },

  // 11️⃣ Messy.fm (Podcast)
  {
    name: 'Work Podcasting Software',
    image: clientsBannerList.messyfm,
    logo: ourClientsCompaniesList.messyfm,
    description:
      'Record, edit, add music, distribute podcasts on a secure, SOC-2 compliant employee and stakeholder listening platform.',

    highlights: [
      { text: '$10M+', variant: 'neon-blue' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MOBILE', variant: 'neon-green' },
      { text: 'PODCASTING', variant: 'neon-green' },
    ],
  },

  // 12️⃣ Indio
  {
    name: 'Simplified Insurance Paperwork',
    image: clientsBannerList.indio,
    logo: ourClientsCompaniesList.indio,
    description:
      'The white-labeled platform comes pre-loaded with a library of 5,000+ digitally enhanced smart insurance forms and applications, a full e-insurance solution.',
    highlights: [
      { text: '$100M+', variant: 'neon-blue' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MOBILE', variant: 'neon-green' },
      { text: 'PROPTECH', variant: 'neon-green' },
    ],
  },

  // 13️⃣ Yogo
  {
    name: 'Intuitive Booking System',
    image: clientsBannerList.yogo,
    logo: ourClientsCompaniesList.yogo,
    description:
      'With YOGO, you quickly and easily get a complete, intuitive booking system. It’s time for a new booking system.',
    highlights: [
      { text: '$10M+', variant: 'neon-blue' },
      { text: 'WEB', variant: 'neon-green' },
      { text: 'MOBILE', variant: 'neon-green' },
      { text: 'PROPTECH', variant: 'neon-green' },
    ],
  },

  // 14️⃣ Dear Brightly
  {
    name: 'First Beauty Tech Company',
    image: clientsBannerList.dearBrightly,
    logo: ourClientsCompaniesList.dearBrightly,
    description:
      'The first cosmetics company based on telehealth. Its mission is to make dermatologist-recommended skincare accessible to everyone.',
    highlights: [
      { text: 'WEB', variant: 'neon-green' },
      { text: 'TELEHEALTH', variant: 'neon-green' },
      { text: 'BEAUTY', variant: 'neon-green' },
      { text: 'YC W18', variant: 'neon-green' },
    ],
  },
];
